"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Styled = __importStar(require("./TitleWithContent.styled"));
var TitleWithContent = function (_a) {
    var children = _a.children, title = _a.title, _b = _a.isLineThrough, isLineThrough = _b === void 0 ? false : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c, className = _a.className;
    return ((0, jsx_runtime_1.jsxs)(Styled.TitleWithContentWrapper, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(Styled.Label, __assign({ isActive: isActive }, { children: title }), void 0), (0, jsx_runtime_1.jsx)(Styled.Content, __assign({ isLineThrough: isLineThrough }, { children: children }), void 0)] }), void 0));
};
exports.default = TitleWithContent;
